import { faPencil } from '@fortawesome/pro-regular-svg-icons/faPencil';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons/faTrashAlt';
import { Room } from '@spike/room-model';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import ThreeDotsDropdown from 'components/UI/V3/ThreeDotsDropdown/ThreeDotsDropdown';
import { useApiClientWrapper, useMasterData } from 'hooks';
import { FunctionComponent, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import RoomNameCell from './RoomNameCell';
import styles from './RoomsTableRow.module.scss';
import DeleteModal from 'components/UI/V3/Modals/DeleteModal';
import { useDispatch, useSelector } from 'react-redux';
import { deleteThunk, RoomsStatus } from '@spike/rooms-action';
import { Root } from 'react-dom/client';
import { RootState } from 'store';
import useNonInitialEffect from '@versiondos/hooks';
import EditRoom from './edit/EditRoom';

interface RoomsTableRowProps {
    room: Room;
    isLast?: boolean;
    className?: string;
}

export const RoomsTableRow: FunctionComponent<RoomsTableRowProps> = props => {
    const masterdata = useMasterData();
    const dispatch = useDispatch();
    const apiClientWrapper = useApiClientWrapper();

    const isMobile = useMediaQuery({ query: '(max-width:600px)' });
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showEdit, setShowEdit] = useState(false);

    const roomsStatus = useSelector<RootState, RoomsStatus>(state => state.rooms.status);

    useNonInitialEffect(() => {
        switch (roomsStatus) {
            case RoomsStatus.DeleteSuccess:
            case RoomsStatus.Error:
                setShowDeleteModal(false);
        }
    }, [roomsStatus]);

    const editOption = {
        id: 'edit',
        label: 'Edit',
        icon: faPencil,
        onClick: () => setShowEdit(true)
    };
    const deleteOption = {
        id: 'delete',
        label: 'Delete',
        icon: faTrashAlt,
        onClick: () => setShowDeleteModal(true)
    };

    const options = [editOption, deleteOption];

    const deleteRoom = () => {
        props.room.id && dispatch(deleteThunk(apiClientWrapper, props.room.id));
    };

    return (
        <>
            <TableRow className={props.className}>
                <TableCell className={styles.nameCell}>
                    <RoomNameCell room={props.room} />
                </TableCell>
                {!isMobile && <TableCell>{props.room.roomType?.name}</TableCell>}
                {!isMobile && <TableCell>{props.room.units.length}</TableCell>}
                {!isMobile && (
                    <TableCell>
                        {props.room.staffIds.length === 0 ? '-' : `${props.room.staffIds.length} Members`}
                    </TableCell>
                )}
                {!isMobile && (
                    <TableCell>
                        {masterdata.ruleTypes.find(rule => rule.id === props.room.rules[0]?.ruleTypeId)?.name ?? ''}
                    </TableCell>
                )}
                <TableCell isActions>
                    <ThreeDotsDropdown
                        options={options}
                        direction={props.isLast ? 'up' : 'down'}
                    />
                </TableCell>
            </TableRow>
            {showDeleteModal && (
                <DeleteModal
                    title="Delete Room"
                    entityName={props.room.name}
                    onConfirm={deleteRoom}
                    onCancel={() => setShowDeleteModal(false)}
                />
            )}
            {showEdit && (
                <EditRoom
                    room={props.room}
                    onClose={() => setShowEdit(false)}
                    onSaved={() => setShowEdit(false)}
                />
            )}
        </>
    );
};

export default RoomsTableRow;
